export type EditRequestSubmitMode =
  | "SAVE_IMMEDIATELY"
  | "RETURN_TO_PREVIEW"
  | "CHOOSE_SCOPE";

/**
 * Routes the Edit Request footer button for patron recurring requests.
 *
 * Unsaved series previews must not open the scope modal or treat the edit as a
 * series submit. Saved series with following requests choose a scope first.
 * A leftover last request is saved immediately like a standalone request.
 */
export const getEditRequestSubmitMode = ({
  isLessonBooking,
  isUnsavedSeriesPreview,
  isRecurringRequest,
}: {
  isLessonBooking: boolean;
  isUnsavedSeriesPreview: boolean;
  isRecurringRequest: boolean;
}): EditRequestSubmitMode => {
  if (isLessonBooking) {
    return "SAVE_IMMEDIATELY";
  }

  if (isUnsavedSeriesPreview) {
    return "RETURN_TO_PREVIEW";
  }

  if (isRecurringRequest) {
    return "CHOOSE_SCOPE";
  }

  return "SAVE_IMMEDIATELY";
};
